export function useSuiteStarterUpgrade(isPaidHub, isProOrEntTrial) {
  const showSuiteStarterButton = !isPaidHub && !isProOrEntTrial;
  return [showSuiteStarterButton];
}